import { Day, HoursOff } from "@mc-intranet/shared";
import { Stack } from "@mui/material";
import { Moment } from "moment";
import React from "react";

import TimeSelector from "../../TimeSelector";

interface Props {
  day?: Day;
  hoursOff?: HoursOff;
  isCreate?: boolean;
  onTimeChange: (time: Moment | null, name: string) => void;
}

const Times: React.FC<Props> = (props) => {
  const { day, hoursOff, isCreate = false, onTimeChange } = props;

  return (
    <>
      <Stack flex={1} direction="row" spacing={2}>
        {/* <span>Da</span> */}
        <TimeSelector
          label="Da"
          name="from"
          date={day?.date}
          punchTime={hoursOff?.from}
          disabled={isCreate ? false : day?.vacation ?? false}
          minuteStep={15}
          onChange={onTimeChange}
        />
      </Stack>
      <Stack flex={1} direction="row" spacing={2}>
        {/* <span>A</span> */}
        <TimeSelector
          label="A"
          name="to"
          date={day?.date}
          punchTime={hoursOff?.to}
          disabled={
            isCreate
              ? false
              : day?.vacation || !hoursOff?.from
          }
          minuteStep={15}
          onChange={onTimeChange}
          inValue={hoursOff?.from}
        />
      </Stack>
    </>
  );
};

export default Times;
